export const LipidColumn = () => (
  <>
    <h4>Lipid column</h4>
    <p>
      The lipid column is parsed with Goslin into sum of carbons and double bonds (e.g. PE 36:0, CL 72:7),
      regardless whether the side chain information is available or not.
      If this is unintended, remove these lipid species before fitting.
    </p>
    <p>
      For mzTab-M the <strong>chemical_name</strong> column of the mzTab-M summary table is treated as the lipid column.
      In other tabular data files, the <strong>first column</strong> is treated as the lipid column.
    </p>
  </>
)
